import Inline from '../blots/inline';

class Underline extends Inline {}
Underline.blotName = 'underline';
Underline.tagName = 'U';

export default Underline;
